import React from 'react';
import InvitationPreviewV2 from '../_components/InvitationPreview/InvitationPreviewV2';
import { INVITATION_TEMPLATES_V2 } from '../_data/invitation-templates-v2';
import { Event } from '../_graphql/generated/operations';

// A contact sheet of every registered template, rendered through the REAL
// preview component rather than a reimplementation of it — so what this page
// shows is what an organiser sees in the designer.
//
// It exists because template design is not reviewable as source: a hex value
// and a font stack tell you nothing about whether two lines collide, whether a
// hairline survives on a dark ground, or whether a font silently fell back to
// a system serif because it was never loaded. All three of those were found
// here by looking.
const stubEvent = {
  id: 'gallery',
  eventName: 'Gallery Preview',
  eventDateTime: Date.now(),
  location: 'Somewhere',
} as unknown as Event;

const TemplateGallery: React.FC = () => (
  <div style={{ background: '#33363B', minHeight: '100vh', padding: 32 }}>
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(360px, 1fr))',
        gap: 32,
        maxWidth: 1560,
        margin: '0 auto',
      }}
    >
      {INVITATION_TEMPLATES_V2.map((design) => (
        <div key={design.template.id}>
          <div
            style={{
              color: '#F2F2F2',
              fontFamily: 'Inter, sans-serif',
              fontSize: 13,
              letterSpacing: 1.5,
              textTransform: 'uppercase',
              marginBottom: 10,
            }}
          >
            {design.template.name}
            <span style={{ opacity: 0.5 }}> · {design.template.category}</span>
          </div>
          <InvitationPreviewV2 design={design} event={stubEvent} />
        </div>
      ))}
    </div>
  </div>
);

export default TemplateGallery;
